import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./slices/cartSlice"; // Adjust the path based on your folder structure
import cartReducer2 from "./slices/cartSlice2"; // Adjust the path based on your folder structure

const store = configureStore({
  reducer: {
    cart: cartReducer,
    cart2: cartReducer2,
  },
});

export default store;
